module.exports = __webpack_public_path__ + "static/img/html-css-collage-concept-with-hacker.7077ac59.jpg";